import { hotelesOpciones } from "../../../hook/Arreglos"; // Importa el arreglo con las opciones de hoteles.
import { UnificarModales } from "../Modales/UnificarModales"; // Importa el componente para manejar modales.

/**
 * Componente de botones para seleccionar salones según el hotel.
 *
 * @param {Function} switchHotel - Función para cambiar el hotel seleccionado.
 *                                 Recibe el ID del hotel como argumento.
 */
export const SalonButtons = ({ switchHotel, type = "mostrar" }) => {
    return (
        <>
            <div className="card-body">
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        alignItems: "flex-end",
                    }}
                >
                    {/* Contenedor para los botones de hoteles */}
                    <div
                        style={{
                            display: "flex",
                            gap: "15px",
                            flexWrap: "wrap",
                            justifyContent: "flex-end",
                        }}
                    >
                        {hotelesOpciones.map((hotel) => (
                            <button
                                key={hotel.value}
                                type="button"
                                style={{
                                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                    backgroundColor: hotel.backgroundColor,
                                    border: "none",
                                    borderRadius: "8px",
                                    padding: "10px 20px",
                                    color: "#ffffff",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    transition: "transform 0.2s ease-in-out",
                                }}
                                className="btn-shadow btn"
                                onClick={() => switchHotel(parseInt(hotel.value, 10))}
                                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                            >
                                <i className="ti ti-building-store"></i> {hotel.label}
                            </button>
                        ))}
                    </div>

                    {/* Contenedor para acciones adicionales */}
                    {type === "mostrar" && (
                        <div
                            style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "flex-end",
                            }}
                        >
                            <button
                                style={{
                                    backgroundColor: "#333333",
                                    color: "#ffffff",
                                    border: "none",
                                    borderRadius: "8px",
                                    padding: "10px 20px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                }}
                            >
                                Crear Clientes
                            </button>
                            <button
                                style={{
                                    backgroundColor: "#333333",
                                    color: "#ffffff",
                                    border: "none",
                                    borderRadius: "8px",
                                    padding: "10px 20px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                }}
                            >
                                Crear Empresa
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
